import { MFLink } from '@medifind/shared-basic-components';
import { useMediaQueryUp } from '@medifind/utils';
import { useLocationStore } from '@medifind/zustand';
import styles from './DoctorsGridDisclaimer.module.scss';

const DoctorsGridDisclaimer = () => {
  const location = useLocationStore();
  const isSmallDesktopAndAbove = useMediaQueryUp('lg');

  if (location?.countryCode === 'US' || location?.countryCode == null) {
    return;
  }

  return (
    <div className={styles['disclaimer']}>
      While we make every effort to provide the best results possible, data is currently limited outside of the United States. Doctors
      listed may include both clinicians and researchers, and individuals relocate frequently. We recommend contacting doctors directly to
      confirm their location and areas of focus. Contact information is provided when available.{' '}
      <MFLink href={`#${isSmallDesktopAndAbove ? 'expert-tiers' : 'expert-tiers-inline'}`}>Learn more</MFLink> about our expert tiers.
    </div>
  );
};

export { DoctorsGridDisclaimer as default, DoctorsGridDisclaimer };
